module.exports = __webpack_public_path__ + "static/8.2_ancient_china-428d4cddef2894df4f9b7e0ba65f32e5.pdf";